"use strict";
var transform = require('common/transform');
var urls = require('common/urls');
var hlp = require('common/helpers');
var FIELD_ORDER = require('registration/fieldOrder');
var DEFAULT_TITLE = 'Neue Erfassung';
var controller = function($scope, $rootScope, $http, id, values, schema, permissions, $uibModal) {
  $scope.urls = urls;
  var doSave = function(location) {
    var fields = transform.toSchema($scope.fields);
    var saveFunc = null;
    if (id != null) {
      saveFunc = function() {
        return $http.post('/api/registration/' + id + '.json', angular.toJson(fields.values));
      };
    } else {
      saveFunc = function() {
        return $http.post('/api/registration.json', angular.toJson(fields.values));
      };
    }
    saveFunc().then(function(response) {
      window.location = location;
    }, function(response) {
      alert("Error saving!");
    });
  };
  $scope.save = function() {
    doSave('/registration');
  };
  $scope.saveAndCreateWork = function() {
    if (id == null) {
      $scope.save();
    } else {
      doSave('/work/new?registrationId=' + $scope.id);
    }
  };
  $scope.saveAndCreateNewRegistration = function() {
    if (id == null) {
      $scope.save();
    } else {
      doSave('/registration/new?registrationId=' + $scope.id);
    }
  };
  $scope.createWork = function() {
    window.location = '/work/new?registrationId=' + $scope.id;
  };
  $scope.createNewRegistration = function() {
    window.location = '/registration/new?registrationId=' + $scope.id;
  };
  $scope.initValidations = function() {
    $scope.validations = {};
    for (var field in $scope.fields) {
      $scope.validations[field] = true;
    }
  };
  $scope.initStates = function() {
    $scope.canEdit = true;
    var hasEditPermission = hlp.hasPermission(permissions, 'edit');
    var hasEditWorkPermission = hlp.hasPermission(permissions, 'editWork');
    if (typeof $scope.values.state == 'undefined' || $scope.values.state != 'workcreated') {
      $scope.values.state = 'new';
    }
    $scope.canCreateNewRegistration = hasEditPermission && ($scope.id != null);
    $scope.canCreateWork = hasEditWorkPermission && ($scope.id != null) && ($scope.values.state != 'workcreated');
    if ($scope.values.state == 'new') {
      $scope.canEdit = hasEditPermission;
    } else if ($scope.values.state == 'workcreated') {
      $scope.canEdit = false;
    }
  };
  $scope.$watch('validations', function() {
    $scope.isValid = true;
    for (var field in $scope.fields) {
      if ($scope.validations[field] == false) {
        $scope.isValid = false;
      }
    }
  }, true);
  $scope.$watch('fields.bildthema.entries', function() {
    if ($scope.fields.bildthema.entries.length > 0 && $scope.fields.bildthema.entries[0].value.length > 0) {
      $scope.title = $scope.fields.bildthema.entries[0].value;
    } else {
      $scope.title = DEFAULT_TITLE;
    }
  }, true);
  $scope.hasPermission = hlp.hasPermission;
  $scope.$watch('title', function() {
    if (hlp.isSet(id) && hlp.isSet($scope.title)) {
      window.document.title = $scope.title + " - Bilderfassung";
    }
  }, true);
  var init = function() {
    $scope.id = id;
    $scope.dias = [];
    if (values.length > 0) {
      $scope.values = JSON.parse(values);
    } else {
      $scope.values = {};
    }
    $scope.permissions = permissions;
    $scope.fields = transform.jsonStringsFromSchema(schema, values);
    if ($scope.fields.bildthema.entries.length == 0 || $scope.fields.bildthema.entries[0].value.length == 0) {
      $scope.fields.bildthema.entries.push({'value': DEFAULT_TITLE});
    }
    $scope.order = FIELD_ORDER;
    $scope.fieldsList = transform.sortFields($scope.fields, $scope.order);
    $scope.initValidations();
    $scope.initStates();
  }();
};
module.exports = controller;
